var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"editUserContainer"}},[_c('user',{attrs:{"user-id":this.$route.params.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }